import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../core'
import * as structures from '../../../structures'
import * as externalInstitutions from '../external-institutions'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from(
      externalInstitutions.RESOURCE.payload,
    ),
    description: 'Primary address of the legal entity',
    isOptional: false,
    name: 'Address',
    partialId: PartialId.Standard.create('address'),
    type: {
      structureId: core.dms.models.Structure.Id.from(
        structures.address.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
